/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../spine/options_pb.js');
var spine_time_time_pb = require('../../spine/time/time_pb.js');
goog.exportSymbol('proto.spine.time.LocalDateChange', null, global);
goog.exportSymbol('proto.spine.time.LocalTimeChange', null, global);
goog.exportSymbol('proto.spine.time.OffsetDateTimeChange', null, global);
goog.exportSymbol('proto.spine.time.OffsetTimeChange', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.time.LocalDateChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.time.LocalDateChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.time.LocalDateChange.displayName = 'proto.spine.time.LocalDateChange';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.time.LocalDateChange.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.time.LocalDateChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.time.LocalDateChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.time.LocalDateChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    previousValue: (f = msg.getPreviousValue()) && spine_time_time_pb.LocalDate.toObject(includeInstance, f),
    newValue: (f = msg.getNewValue()) && spine_time_time_pb.LocalDate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.time.LocalDateChange}
 */
proto.spine.time.LocalDateChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.time.LocalDateChange;
  return proto.spine.time.LocalDateChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.time.LocalDateChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.time.LocalDateChange}
 */
proto.spine.time.LocalDateChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_time_time_pb.LocalDate;
      reader.readMessage(value,spine_time_time_pb.LocalDate.deserializeBinaryFromReader);
      msg.setPreviousValue(value);
      break;
    case 2:
      var value = new spine_time_time_pb.LocalDate;
      reader.readMessage(value,spine_time_time_pb.LocalDate.deserializeBinaryFromReader);
      msg.setNewValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.time.LocalDateChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.time.LocalDateChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.time.LocalDateChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.time.LocalDateChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreviousValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_time_time_pb.LocalDate.serializeBinaryToWriter
    );
  }
  f = message.getNewValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_time_time_pb.LocalDate.serializeBinaryToWriter
    );
  }
};


/**
 * optional LocalDate previous_value = 1;
 * @return {?proto.spine.time.LocalDate}
 */
proto.spine.time.LocalDateChange.prototype.getPreviousValue = function() {
  return /** @type{?proto.spine.time.LocalDate} */ (
    jspb.Message.getWrapperField(this, spine_time_time_pb.LocalDate, 1));
};


/** @param {?proto.spine.time.LocalDate|undefined} value */
proto.spine.time.LocalDateChange.prototype.setPreviousValue = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.time.LocalDateChange.prototype.clearPreviousValue = function() {
  this.setPreviousValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.time.LocalDateChange.prototype.hasPreviousValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LocalDate new_value = 2;
 * @return {?proto.spine.time.LocalDate}
 */
proto.spine.time.LocalDateChange.prototype.getNewValue = function() {
  return /** @type{?proto.spine.time.LocalDate} */ (
    jspb.Message.getWrapperField(this, spine_time_time_pb.LocalDate, 2));
};


/** @param {?proto.spine.time.LocalDate|undefined} value */
proto.spine.time.LocalDateChange.prototype.setNewValue = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.time.LocalDateChange.prototype.clearNewValue = function() {
  this.setNewValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.time.LocalDateChange.prototype.hasNewValue = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.time.LocalTimeChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.time.LocalTimeChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.time.LocalTimeChange.displayName = 'proto.spine.time.LocalTimeChange';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.time.LocalTimeChange.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.time.LocalTimeChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.time.LocalTimeChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.time.LocalTimeChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    previousValue: (f = msg.getPreviousValue()) && spine_time_time_pb.LocalTime.toObject(includeInstance, f),
    newValue: (f = msg.getNewValue()) && spine_time_time_pb.LocalTime.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.time.LocalTimeChange}
 */
proto.spine.time.LocalTimeChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.time.LocalTimeChange;
  return proto.spine.time.LocalTimeChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.time.LocalTimeChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.time.LocalTimeChange}
 */
proto.spine.time.LocalTimeChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_time_time_pb.LocalTime;
      reader.readMessage(value,spine_time_time_pb.LocalTime.deserializeBinaryFromReader);
      msg.setPreviousValue(value);
      break;
    case 2:
      var value = new spine_time_time_pb.LocalTime;
      reader.readMessage(value,spine_time_time_pb.LocalTime.deserializeBinaryFromReader);
      msg.setNewValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.time.LocalTimeChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.time.LocalTimeChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.time.LocalTimeChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.time.LocalTimeChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreviousValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_time_time_pb.LocalTime.serializeBinaryToWriter
    );
  }
  f = message.getNewValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_time_time_pb.LocalTime.serializeBinaryToWriter
    );
  }
};


/**
 * optional LocalTime previous_value = 1;
 * @return {?proto.spine.time.LocalTime}
 */
proto.spine.time.LocalTimeChange.prototype.getPreviousValue = function() {
  return /** @type{?proto.spine.time.LocalTime} */ (
    jspb.Message.getWrapperField(this, spine_time_time_pb.LocalTime, 1));
};


/** @param {?proto.spine.time.LocalTime|undefined} value */
proto.spine.time.LocalTimeChange.prototype.setPreviousValue = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.time.LocalTimeChange.prototype.clearPreviousValue = function() {
  this.setPreviousValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.time.LocalTimeChange.prototype.hasPreviousValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LocalTime new_value = 2;
 * @return {?proto.spine.time.LocalTime}
 */
proto.spine.time.LocalTimeChange.prototype.getNewValue = function() {
  return /** @type{?proto.spine.time.LocalTime} */ (
    jspb.Message.getWrapperField(this, spine_time_time_pb.LocalTime, 2));
};


/** @param {?proto.spine.time.LocalTime|undefined} value */
proto.spine.time.LocalTimeChange.prototype.setNewValue = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.time.LocalTimeChange.prototype.clearNewValue = function() {
  this.setNewValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.time.LocalTimeChange.prototype.hasNewValue = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.time.OffsetTimeChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.time.OffsetTimeChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.time.OffsetTimeChange.displayName = 'proto.spine.time.OffsetTimeChange';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.time.OffsetTimeChange.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.time.OffsetTimeChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.time.OffsetTimeChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.time.OffsetTimeChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    previousValue: (f = msg.getPreviousValue()) && spine_time_time_pb.OffsetTime.toObject(includeInstance, f),
    newValue: (f = msg.getNewValue()) && spine_time_time_pb.OffsetTime.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.time.OffsetTimeChange}
 */
proto.spine.time.OffsetTimeChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.time.OffsetTimeChange;
  return proto.spine.time.OffsetTimeChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.time.OffsetTimeChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.time.OffsetTimeChange}
 */
proto.spine.time.OffsetTimeChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_time_time_pb.OffsetTime;
      reader.readMessage(value,spine_time_time_pb.OffsetTime.deserializeBinaryFromReader);
      msg.setPreviousValue(value);
      break;
    case 2:
      var value = new spine_time_time_pb.OffsetTime;
      reader.readMessage(value,spine_time_time_pb.OffsetTime.deserializeBinaryFromReader);
      msg.setNewValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.time.OffsetTimeChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.time.OffsetTimeChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.time.OffsetTimeChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.time.OffsetTimeChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreviousValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_time_time_pb.OffsetTime.serializeBinaryToWriter
    );
  }
  f = message.getNewValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_time_time_pb.OffsetTime.serializeBinaryToWriter
    );
  }
};


/**
 * optional OffsetTime previous_value = 1;
 * @return {?proto.spine.time.OffsetTime}
 */
proto.spine.time.OffsetTimeChange.prototype.getPreviousValue = function() {
  return /** @type{?proto.spine.time.OffsetTime} */ (
    jspb.Message.getWrapperField(this, spine_time_time_pb.OffsetTime, 1));
};


/** @param {?proto.spine.time.OffsetTime|undefined} value */
proto.spine.time.OffsetTimeChange.prototype.setPreviousValue = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.time.OffsetTimeChange.prototype.clearPreviousValue = function() {
  this.setPreviousValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.time.OffsetTimeChange.prototype.hasPreviousValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OffsetTime new_value = 2;
 * @return {?proto.spine.time.OffsetTime}
 */
proto.spine.time.OffsetTimeChange.prototype.getNewValue = function() {
  return /** @type{?proto.spine.time.OffsetTime} */ (
    jspb.Message.getWrapperField(this, spine_time_time_pb.OffsetTime, 2));
};


/** @param {?proto.spine.time.OffsetTime|undefined} value */
proto.spine.time.OffsetTimeChange.prototype.setNewValue = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.time.OffsetTimeChange.prototype.clearNewValue = function() {
  this.setNewValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.time.OffsetTimeChange.prototype.hasNewValue = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.time.OffsetDateTimeChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.time.OffsetDateTimeChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.time.OffsetDateTimeChange.displayName = 'proto.spine.time.OffsetDateTimeChange';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.time.OffsetDateTimeChange.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.time.OffsetDateTimeChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.time.OffsetDateTimeChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.time.OffsetDateTimeChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    previousValue: (f = msg.getPreviousValue()) && spine_time_time_pb.OffsetDateTime.toObject(includeInstance, f),
    newValue: (f = msg.getNewValue()) && spine_time_time_pb.OffsetDateTime.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.time.OffsetDateTimeChange}
 */
proto.spine.time.OffsetDateTimeChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.time.OffsetDateTimeChange;
  return proto.spine.time.OffsetDateTimeChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.time.OffsetDateTimeChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.time.OffsetDateTimeChange}
 */
proto.spine.time.OffsetDateTimeChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_time_time_pb.OffsetDateTime;
      reader.readMessage(value,spine_time_time_pb.OffsetDateTime.deserializeBinaryFromReader);
      msg.setPreviousValue(value);
      break;
    case 2:
      var value = new spine_time_time_pb.OffsetDateTime;
      reader.readMessage(value,spine_time_time_pb.OffsetDateTime.deserializeBinaryFromReader);
      msg.setNewValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.time.OffsetDateTimeChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.time.OffsetDateTimeChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.time.OffsetDateTimeChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.time.OffsetDateTimeChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreviousValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_time_time_pb.OffsetDateTime.serializeBinaryToWriter
    );
  }
  f = message.getNewValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_time_time_pb.OffsetDateTime.serializeBinaryToWriter
    );
  }
};


/**
 * optional OffsetDateTime previous_value = 1;
 * @return {?proto.spine.time.OffsetDateTime}
 */
proto.spine.time.OffsetDateTimeChange.prototype.getPreviousValue = function() {
  return /** @type{?proto.spine.time.OffsetDateTime} */ (
    jspb.Message.getWrapperField(this, spine_time_time_pb.OffsetDateTime, 1));
};


/** @param {?proto.spine.time.OffsetDateTime|undefined} value */
proto.spine.time.OffsetDateTimeChange.prototype.setPreviousValue = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.time.OffsetDateTimeChange.prototype.clearPreviousValue = function() {
  this.setPreviousValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.time.OffsetDateTimeChange.prototype.hasPreviousValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OffsetDateTime new_value = 2;
 * @return {?proto.spine.time.OffsetDateTime}
 */
proto.spine.time.OffsetDateTimeChange.prototype.getNewValue = function() {
  return /** @type{?proto.spine.time.OffsetDateTime} */ (
    jspb.Message.getWrapperField(this, spine_time_time_pb.OffsetDateTime, 2));
};


/** @param {?proto.spine.time.OffsetDateTime|undefined} value */
proto.spine.time.OffsetDateTimeChange.prototype.setNewValue = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.time.OffsetDateTimeChange.prototype.clearNewValue = function() {
  this.setNewValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.time.OffsetDateTimeChange.prototype.hasNewValue = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.spine.time);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../known_type_parsers.js');

proto.spine.time.LocalDateChange.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.time.LocalDateChange.fromObject(jsObject);
};

proto.spine.time.LocalDateChange.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.time.LocalDateChange();
  
  if (obj.previousValue !== undefined) {
    if (obj.previousValue === null) {
      msg.setPreviousValue(null);
    } else {
      let value = proto.spine.time.LocalDate.fromObject(obj.previousValue);
      msg.setPreviousValue(value);
    }
  }
  
  if (obj.newValue !== undefined) {
    if (obj.newValue === null) {
      msg.setNewValue(null);
    } else {
      let value = proto.spine.time.LocalDate.fromObject(obj.newValue);
      msg.setNewValue(value);
    }
  }
  return msg;
};

proto.spine.time.LocalTimeChange.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.time.LocalTimeChange.fromObject(jsObject);
};

proto.spine.time.LocalTimeChange.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.time.LocalTimeChange();
  
  if (obj.previousValue !== undefined) {
    if (obj.previousValue === null) {
      msg.setPreviousValue(null);
    } else {
      let value = proto.spine.time.LocalTime.fromObject(obj.previousValue);
      msg.setPreviousValue(value);
    }
  }
  
  if (obj.newValue !== undefined) {
    if (obj.newValue === null) {
      msg.setNewValue(null);
    } else {
      let value = proto.spine.time.LocalTime.fromObject(obj.newValue);
      msg.setNewValue(value);
    }
  }
  return msg;
};

proto.spine.time.OffsetTimeChange.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.time.OffsetTimeChange.fromObject(jsObject);
};

proto.spine.time.OffsetTimeChange.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.time.OffsetTimeChange();
  
  if (obj.previousValue !== undefined) {
    if (obj.previousValue === null) {
      msg.setPreviousValue(null);
    } else {
      let value = proto.spine.time.OffsetTime.fromObject(obj.previousValue);
      msg.setPreviousValue(value);
    }
  }
  
  if (obj.newValue !== undefined) {
    if (obj.newValue === null) {
      msg.setNewValue(null);
    } else {
      let value = proto.spine.time.OffsetTime.fromObject(obj.newValue);
      msg.setNewValue(value);
    }
  }
  return msg;
};

proto.spine.time.OffsetDateTimeChange.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.time.OffsetDateTimeChange.fromObject(jsObject);
};

proto.spine.time.OffsetDateTimeChange.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.time.OffsetDateTimeChange();
  
  if (obj.previousValue !== undefined) {
    if (obj.previousValue === null) {
      msg.setPreviousValue(null);
    } else {
      let value = proto.spine.time.OffsetDateTime.fromObject(obj.previousValue);
      msg.setPreviousValue(value);
    }
  }
  
  if (obj.newValue !== undefined) {
    if (obj.newValue === null) {
      msg.setNewValue(null);
    } else {
      let value = proto.spine.time.OffsetDateTime.fromObject(obj.newValue);
      msg.setNewValue(value);
    }
  }
  return msg;
};
